import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { brand } from '@/brand';
import { getScreen } from '@/app/navigation/screens';
import { useNavTranslate } from '@/app/navigation/useNavTranslate';

// Централизованный заголовок вкладки по маршруту. Подключён в MainLayout —
// меняется при переходе по любому пункту навбара. Заголовки берутся из реестра
// экранов: раньше здесь лежала своя копия карты путей, и добавление страницы
// требовало правки в трёх местах.
//
// Сопоставление — через matchPath по тем же шаблонам, что у роутера, вместо
// прежних самодельных регулярок. Побочный эффект, намеренный: путь вида
// /support/abc теперь получает заголовок «Тикет» (раньше — имя бренда), то
// есть заголовок наконец совпадает с тем, какая страница реально отрисована.

const BRAND = import.meta.env.VITE_BRAND_TITLE || 'Wap';

export function usePageTitle() {
  const { pathname } = useLocation();
  const tNav = useNavTranslate();

  useEffect(() => {
    const screen = brand.screens
      .map(getScreen)
      .find(({ path }) => matchPath({ path, end: true }, pathname));

    if (!screen) {
      document.title = BRAND;
      return;
    }

    document.title = tNav(screen.titleKey);
  }, [pathname, tNav]);
}
